import { combineEpics } from 'redux-observable';
import { Epic1, Epic2, NewsEpic } from '../redux/home/epic';
import {SendOTPEpic,VerifyOtpEpic} from '../redux/login/epic';
import { CreateRecordEpic } from '../redux/records/epic';

export default combineEpics(Epic1, Epic2,SendOTPEpic,VerifyOtpEpic,CreateRecordEpic,NewsEpic);
